import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import Pay from '@containers/Pay';
import { Form, Formik } from 'formik';
import CancelIcon from '@assets/images/CancelIcon.png';
import style from './paymentScreens.module.scss';
import SimpleKeyBoard from '@components/common/formElements/SimpleKeyboard';
import CustomKeyboard from '@components/common/CustomKeyboard/index';
import Survey from '@containers/Survey';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import GiftCard from './giftCard';
import QrPayFromPhone from './QrPayFromPhone';
import tick from '@assets/images/tick_green.png';
import handOff from '@assets/images/HAND_OFF.gif';
import CashReturn from '@components/CashReturn';
import Button from '@components/common/LongPressButton';
import Modal from '@components/common/Modal';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import TipsConfirmPopUp from '../../containers/ViewReceipt/tipsConfirmationPopUp';

const PaymentScreen = ({
  receiptTypes,
  isCounter,
  history,
  handleCreditCard,
  onChangeTipAmount,
  onChangeTipPersent,
  handleButtonClickOtherAmount,
  tipsMessage,
  paymentType,
  sourceType,
  setTextToPayModelOpen,
  stopPopUpOtherAmount,
  currenySymbol,
  paymentAmount,
  preAuthFunctionCall,
  setPaymentType,
  unpaidAmount,
  totalAmount,
  tipAmount,
  handleRouteCheck,
  handleCheck,
  logo,
  makeGiftCardBalanceZero,
  handleButtonClick,
  tipsList,
  active,
  paymentCallBack,
  handleReceiptPopUpOpen,
  handleRetry,
  PaymentPageBtn,
  handleSplitEvenly,
  handlePayAnAmount,
  isCash,
  handleKeyboardValue,
  validatePayAnAmount,
  subTotalAmount,
  handleSurveySubmit,
  isGiftCard,
  isSecurityCode,
  handleGiftCard,
  giftCardPayment,
  giftBalance,
  setGiftBalance,
  paidAmount,
  giftCardSupportsSwipe,
  openCardPopUp,
  giftCardNumber,
  handleFailureRoute,
  isCreditCard,
  handleProcessCreditError,
  isDone,
  totalAmountForTip,
  charity,
  charityList,
  handleTipsRouteTo,
  applyDonation,
  handleGiftCancel,
  isQrScan,
  isKiosk,
  isTableTop,
  isServerApp,
  authResponse,
  tableData,
  deviceInfo,
  handleHideCancelIcon,
  handleChangePaymentType,
  userInfo,
  handleDirectToCashConfirmation,
  isPaymentTerminal,
  isExternalCreditCard,
  isTextToPay,
  giftCardImages,
  setNotification,
  setIsOpen,
  isOpen,
  handleBackButton,
  giftCardMethods,
  setTipAmount,
  checkboxactive,
  setCheckboxactive,
  setCheckboxactives,
  authInfo,
  ShowLandscapeMode,
  countryCode,
  headerImg,
  smsEmailPrintObject,
  setsmsEmailPrintObject,
  handleNoReceipt,
  handleRouteRetry,
  disableOtherTip,
  enableOtherAmount,
  enableOtherPercent,
  selectedPayment,
  validateTipsForCredit,
  partialPayment,
  continueGiftCardPayment,
  swipeGiftCard,
  allMenuItems,
  isCallCenter,
  setShowNoTipModal,
  showNoTipModal,
}) => {
  const otherAmountName = 'otheramountname';
  const [inputName, setInputName] = useState(`${otherAmountName}`);
  const [inputs, setInputs] = useState({});
  const themeProperties =
    JSON.parse(window.sessionStorage.getItem('themeProperties')) || {};
  const amountToshow =
    JSON.parse(window.sessionStorage.getItem('paymentCheck')) || {};
  const [tipList, setTipList] = useState([]);
  const [tipvalue, setTipvalue] = useState('0%');
  const [value, setValue] = useState('$0.00');
  const [totalVisible, setTotalVisible] = useState({
    amount: true,
    percent: false,
  });
  const [btnPrimary, setBtnPrimary] = useState({
    isAmount: 'od-btn-primary btn-primary',
    isPercent: 'od-btn-secondary',
  });
  const [otherObject, setOtherObject] = useState({});
  const callCenterModeUserInfo = JSON.parse(
    window.sessionStorage.getItem('callCenterUserInfo')
  );
  const getConfirmationLogo = () => {
    let image = logo;
    console.log('getConfirmationLogo', logo);
    if (isKiosk) {
      image = themeProperties.kioskConfirmationPageImageUrl;
    } else if (isTableTop) {
      image = themeProperties.tableTopConfirmationPageImageUrl;
    } else if (isServerApp) {
      image = themeProperties.serverAppConfirmationPageImageUrl;
      console.log(
        'isserverapp',
        themeProperties.serverAppConfirmationPageImageUrl
      );
    } else if (isPaymentTerminal) {
      image = themeProperties.serverAppConfirmationPageImageUrl;
      console.log(
        'isPaymentTerminal',
        themeProperties.serverAppConfirmationPageImageUrl
      );
    }
    return image;
  };
  const buttonAllignment = () => {
    const btn_value = Object.values(receiptTypes).filter(val => val === true)
      .length;
    if (btn_value === 1) {
      return 'col-12';
    } else if (btn_value === 2) {
      return 'col-6';
    } else if (btn_value === 3) {
      return 'col-4';
    }
  };

  const handleReceiptType = () => {
    smsEmailPrintObject.smsReceiptStatus &&
      setsmsEmailPrintObject(!smsEmailPrintObject.smsReceiptStatus);
    smsEmailPrintObject.emailReceiptStatus &&
      setsmsEmailPrintObject(!smsEmailPrintObject.emailReceiptStatus);
    smsEmailPrintObject.printReceiptStatus &&
      setsmsEmailPrintObject(!smsEmailPrintObject.printReceiptStatus);
  };

  const StartScreen = () => {
    const payAnAmountBtn = PaymentPageBtn.find(btn => {
      return btn?.name === 'Pay Full Check';
    });
    return (
      <div
        className={cn(
          'col-12 h-100 row mx-0 px-0 align-items-center justify-content-center py-1 mt-40'
        )}
      >
        {payAnAmountBtn !== undefined ? (
          <div className="col-12 w-100 px-0">
            <button
              key={payAnAmountBtn.name}
              type="button"
              onClick={() => {
                payAnAmountBtn.click();
              }}
              style={{ height: isPaymentTerminal ? '10vh' : '11vh' }}
              className={cn(
                  'col-12 btn my-1 px-1 od-btn-primary btn-primary btn-ripple',
                payAnAmountBtn.disabled ? style.opacity6 : ''
              )}
              disabled={payAnAmountBtn.disabled}
            >
              <div
                className={cn('fs-18', style.divForPayment)}
                style={{
                  fontSize: isPaymentTerminal ? '1.8rem' : '18px',
                  textTransform: 'uppercase',
                }}
              >
                {payAnAmountBtn.name}
              </div>
            </button>
          </div>
        ) : (
          ''
        )}
        <div className="col-12 flex-row row px-0">
          {PaymentPageBtn?.map((item, index) => {
            return (
              item &&
              item.name !== 'Pay Full Check' && (
                <button
                  key={item.name}
                  type="button"
                  onClick={() => {
                    item.click();
                  }}
                  style={{ height: isPaymentTerminal ? '10vh' : '11vh' }}
                  className={cn(
                    'col btn my-1 od-btn-primary btn-primary btn-ripple',
                    item.disabled ? style.opacity6 : '',
                    PaymentPageBtn.length === 3 && index === 2 ? 'ml-1' : '',
                    index === 0 ? 'col-12' : ''
                  )}
                  disabled={item.disabled}
                >
                  <div
                    className={cn('fs-18', style.divForPayment)}
                    style={{
                      fontSize: isPaymentTerminal ? '6vw' : '18px',
                      textTransform: 'uppercase',
                    }}
                  >
                    {item.name}
                  </div>
                </button>
              )
            );
          })}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (tipsList.length > 0) {
      for (let index = 0; index < tipsList.length; index++) {
        const element = tipsList[index];
        if (index === tipsList.length - 1) {
          setOtherObject(element);
        } else {
          setTipList(tipList => [...tipList, element]);
        }
      }
    }
  }, []);

  useEffect(() => {
    setTipvalue('0%');
    setValue(currenySymbol + '0.00');
    setInputs({
      ...inputs,
      [inputName]: '',
    });
  }, [paymentType]);

  const Fullcheck = () => {
    return (
      <>
        <div className="col-12 px-0 pl-20 pr-20">
          {ShowLandscapeMode && (
            <div
              className={cn(
                'col-12 row m-auto text-center text-primary od-text-primary',
                style.divForPayment
              )}
              style={{
                fontSize: isServerApp ? '2rem' : '20px',
                bottom: '20vh',
              }}
            >
              {' '}
              {CUSTOM_MESSAGES().PAYMENT_OPTION_SELECTION}
            </div>
          )}

          {isCreditCard && (
            <button
              type="button"
              className={cn(
                'btn80 btn my-1 w-100 od-btn-primary btn-primary btn-ripple ',
                subTotalAmount === 0 ? style.opacity6 : ''
              )}
              onClick={() => handleCheck('creditCard')}
              disabled={subTotalAmount === 0}
            >
              <div
                className={cn('fs-18', style.divForPayment)}
                style={{
                  fontSize: isPaymentTerminal
                    ? '1.8rem'
                    : ShowLandscapeMode
                      ? '24px'
                      : '40px',
                  textTransform: 'uppercase',
                }}
              >
                {LABEL().CREDIT_CARD}
              </div>
            </button>
          )}
        </div>
        <div className="col-12 px-0 h-50 flex-row row mx-0 align-items-center justify-content-end">
          {isQrScan && (
            <button
              type="button"
              className={cn(
                'col btn80 btn mx-1 od-btn-primary btn-primary btn-ripple my-1',
                isTableTop ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              onClick={() => handleCheck('qrPay')}
              disabled={isTableTop}
            >
              <div className="fs-18">{LABEL().QR_PAY_FROM_PHONE}</div>
            </button>
          )}
          {sourceType !== 0 && !isTableTop && isTextToPay && (
            <button
              type="button"
              disabled={sourceType === 7}
              className={cn(
                'col btn80 btn mx-1 od-btn-primary btn-primary btn-ripple my-1 ',
                sourceType === 7 ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              onClick={() => setTextToPayModelOpen(true)}
            >
              <div
                className="fs-18 text-uppercase"
                style={{ fontSize: isPaymentTerminal ? '1.8rem' : '40px' }}
              >
                {LABEL().TEXT_TO_PAY}
              </div>
            </button>
          )}
          {isCash && (
            <Button
              type="button"
              className={cn(
                'col btn80 btn mx-1 od-btn-primary btn-primary btn-ripple my-1 text-underline',
                isTableTop ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              onClick={() => handleCheck('cash')}
              onLongPress={() => {
                handleDirectToCashConfirmation(true);
                handleCheck('cash');
              }}
              disabled={isTableTop}
            >
              <div
                className={cn('fs-18', style.divForPayment)}
                style={{
                  fontSize: isPaymentTerminal
                    ? '1.8rem'
                    : ShowLandscapeMode
                      ? '24px'
                      : '40px',
                  textTransform: 'uppercase',
                }}
              >
                {LABEL().CASH_PAYMENT}
              </div>
            </Button>
          )}
          {isGiftCard && (
            <button
              type="button"
              className={cn(
                'col btn80 btn mx-1 my-1 od-btn-primary btn-primary btn-ripple ',
                subTotalAmount === 0 ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              onClick={() => handleCheck('giftCard')}
              disabled={subTotalAmount === 0}
            >
              <div
                className={cn('fs-18', style.divForPayment)}
                style={{
                  fontSize: isPaymentTerminal
                    ? '1.8rem'
                    : ShowLandscapeMode
                      ? '24px'
                      : '40px',
                  textTransform: 'uppercase',
                }}
              >
                {LABEL().GIFT_CARD}
              </div>
            </button>
          )}
          {isExternalCreditCard && (
            <button
              type="button"
              className={cn(
                'col btn80 btn mx-1 my-1 od-btn-primary btn-primary btn-ripple ',
                subTotalAmount === 0 ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              onClick={() => handleCheck('externalCreditCard')}
              disabled={subTotalAmount === 0 || unpaidAmount === 0}
            >
              <div
                className={cn('fs-18', style.divForPayment)}
                style={{
                  fontSize: isPaymentTerminal ? '1.8rem' : '30px',
                  textTransform: 'uppercase',
                }}
              >
                {LABEL().EXTERNALCREDIT_CARD}
              </div>
            </button>
          )}
          {urlSearchParams('externalCreditCard') && !isExternalCreditCard && (
            <button
              type="button"
              className={cn(
                'col btn80 btn mx-1 my-1 od-btn-primary btn-primary btn-ripple ',
                subTotalAmount === 0 ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              onClick={() => handleCheck('externalCreditCard')}
              disabled={subTotalAmount === 0 || unpaidAmount === 0}
            >
              <div
                className="fs-18"
                style={{
                  fontSize: isPaymentTerminal ? '16px' : '30px',
                  textTransform: 'uppercase',
                }}
              >
                {LABEL().EXTERNALCREDIT_CARD}
              </div>
            </button>
          )}
        </div>
        <Modal isOpen={isOpen} isModalCenter>
          <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
            <div className="px-0 text-right">
              <i
                role="presentation"
                onClick={() => setIsOpen(false)}
                className="fa fa-times fs-30"
                aria-hidden="true"
              />
            </div>
            <div className="col-12 fs-18 mt-10 fw-700 text-center">
              <div className="fs-20">
                {CUSTOM_MESSAGES().PREAUTH_POST_ONE}
                {totalAmount} {CUSTOM_MESSAGES().PREAUTH_POST_TWO}
              </div>
            </div>
            <div className="col-12 d-flex justify-content-center">
              <button
                type="submit"
                className="col-4 m-2 btn btn-ripple btn-secondary btn-lg od-btn-secondary"
                onClick={() => setIsOpen(false)}
              >
                <div className="fs-18">{LABEL().NO}</div>
              </button>
              <button
                type="submit"
                className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary"
                onClick={() => {
                  handleCheck('preAuth');
                  setIsOpen(false);
                }}
              >
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  };

  const mewVal = val => {
    const newValdata = val.toString().split('.');
    if (newValdata[1]) {
      const newstr = newValdata[1].substring(0, 2);
      if (Number(newstr) > 0) {
        return val.toFixed(2);
      } else {
        return newValdata[0];
      }
    }
    return val;
  };
  console.log(countryCode, 'ggg');
  const Tips = () => {
    return (
      <div className="col-12 h-100 row mx-0" style={{ lineHeight: '1.2' }}>
        {!isCounter &&
          !(authInfo?.tipImageUrl == null && authInfo?.imageUrl == '') &&
          !(authInfo?.tipImageUrl == '' && authInfo?.imageUrl == null) &&
          !(authInfo?.tipImageUrl == null && authInfo?.imageUrl == null) &&
          !(authInfo?.tipImageUrl == '' && authInfo?.imageUrl == '') && (
            <div className="col-12">
              {' '}
              <img
                src={authInfo?.tipImageUrl || authInfo?.imageUrl}
                style={{ width: '100%', height: '96px' }}
                alt="tip"
              />
            </div>
          )}
        {tipList && tipList.length > 0 ? (
          <div
            className={cn('col-12 pl-0', isCounter ? 'h-80' : 'h-70')}
            style={!isCounter ? { position: 'absolute', bottom: '18%' } : {}}
          >
            <div
              className={cn(
                'col-12 m-0 px-5 od-text-primary text-center',
                style.divForPayment
              )}
              style={{ fontSize: isServerApp ? '2rem' : '20px' }}
            >
              {LABEL().CHECK_TOTAL_TIP}
            </div>
            <div
              className={cn('col-12 text-center', style.divForPayment)}
              style={{ fontSize: !isCounter ? '20vw' : '1rem' }}
            >
              {currenySymbol}
              {tableData &&
                (tableData.totalAmount - tableData.paidAmount).toFixed(2)}
            </div>
            <div
              className={cn(
                'col-12 od-text-primary m-0 mx-2 text-center',
                style.divForPayment
              )}
              style={{ fontSize: isServerApp ? '2rem' : '20px' }}
            >
              {LABEL().PLEASE_SELECT_TIP}:
            </div>
            <div
              className={cn(
                isCounter || ShowLandscapeMode
                  ? 'col-12 od-text-primary text-center pt-2'
                  : 'col-12 od-text-primary text-center pt-1 fs-20 fw-700'
              )}
            >
              <div className={isCounter ? style.counterWrapper : style.wrapper}>
                {tipList.map(item => {
                  return (
                    <div
                      key={item.key}
                      role="presentation"
                      onClick={() => {
                        handleKeyboardValue('');
                        handleButtonClick(item.key);
                      }}
                      className={cn(
                        isCounter
                          ? 'border border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center h-65'
                          : 'border border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center  rounded',
                        style.divForPayment,
                        item.key === active
                          ? 'text-white'
                          : 'bg-grey color-white od-btn-secondary',
                        style.gridItem,
                        item.key === active ? 'od-btn-primary' : null,
                        isCounter && 'w-32 py-2'
                      )}
                      style={{ fontSize: isServerApp ? '2rem' : '20px' }}
                    >
                      <div>
                        {item?.ruleType === 2 && '$'}
                        {item?.ruleType === 1
                          ? mewVal(item.key)
                          : item.key.toFixed(2)}
                        {item?.ruleType === 1 && '%'}
                      </div>
                      {item.ruleType === 1 && ![4, 5].includes(item.id) && (
                        <div>
                          ({LABEL().CURRENCY_SYMBOL}
                          {(
                            (Number(totalAmountForTip) * Number(item.key)) /
                            100
                          ).toFixed(2)}
                          )
                        </div>
                      )}
                      {item.key === active && [4, 5].includes(item.id) && (
                        <div>
                          ({LABEL().CURRENCY_SYMBOL}
                          {Number(tipAmount).toFixed(2)})
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {disableOtherTip && (enableOtherAmount || enableOtherPercent) && (
                <div className={cn('pt-4')}>
                  <div
                    role="presentation"
                    onClick={() => {
                      handleKeyboardValue('');
                      handleButtonClickOtherAmount(otherObject.key);
                    }}
                    className={cn(
                      isCounter
                        ? 'border border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center'
                        : 'border border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center  rounded',
                      style.divForPayment,
                      'bg-grey color-white od-btn-secondary',
                      style.gridItem
                    )}
                    style={{
                      height: isCounter ? '15vh' : '10vh',
                      fontSize: isServerApp ? '2rem' : '20px',
                    }}
                  >
                    {LABEL().OTHER_AMOUNT}
                  </div>
                </div>
              )}
              {!authInfo?.tipInfo?.disableNoTip && (
                <div className="mt-2">
                  <div
                    className="text-underline py-1 color-primary"
                    onClick={() =>
                      setShowNoTipModal(prevState => ({
                        ...prevState,
                        state: true,
                      }))
                    }
                  >
                    No Tip
                  </div>
                  {/* <div className='mt-1' style={{fontSize: 'Max(1.5vw, 1.5vh)'}}>
                        {CUSTOM_MESSAGES().NO_TIP_AMOUNT}
                      </div> */}
                  <TipsConfirmPopUp
                    isOpen={showNoTipModal.state}
                    onClose={() =>
                      setShowNoTipModal(prevState => ({
                        ...prevState,
                        state: false,
                      }))
                    }
                    tipAmount={0}
                    totalAmountForTip={tableData.subTotalAmount.toFixed(2)}
                    onSubmitTips={() => {
                      setTipAmount(0);
                      setShowNoTipModal(prevState => ({
                        ...prevState,
                        state: false,
                        tip: 'No tip',
                      }));
                      handleButtonClick('');
                      !isCounter && selectedPayment !== 'giftCard'
                        ? setPaymentType(23)
                        : handleCheck('tips', 'No Tip');
                    }}
                  />
                </div>
              )}
            </div>
            <div className="col-12 text-center mt-2 fs-22">
              {
                CUSTOM_MESSAGES()
                  .Suggested_tip_is_calculated_on_check_disclaimer
              }
            </div>
            <div></div>
          </div>
        ) : (
          <div className={cn('col-12 pt-2')}>
            <div
              className={cn(
                'col-12 fs-30 fw-700 m-0 my-2 od-text-primary text-center',
                style.divForPayment
              )}
            >
              {LABEL().CHECK_TOTAL_TIP} {currenySymbol}
              {tableData &&
                (tableData.totalAmount - tableData.paidAmount).toFixed(2)}
            </div>
            <div
              className={cn(
                'col-12 fs-30 fw-700 od-text-primary m-2 text-center',
                style.divForPayment
              )}
            >
              {LABEL().PLEASE_SELECT_TIP}:
            </div>
            <div
              role="presentation"
              onClick={() => {
                handleKeyboardValue('');
                handleButtonClickOtherAmount(otherObject.key);
              }}
              className={cn(
                isCounter
                  ? 'border border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center h-50'
                  : 'border border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center  rounded',
                style.divForPayment,
                'bg-grey color-white od-btn-secondary',
                style.gridItem
              )}
              style={{ height: '10vh' }}
            >
              {LABEL().OTHER_AMOUNT}
            </div>
            {!authInfo?.tipInfo?.disableNoTip && (
              <div className="mt-2 text-center">
                <div
                  className="text-underline py-1"
                  style={{ backgroundColor: 'white', color: 'black' }}
                  onClick={() =>
                    setShowNoTipModal(prevState => ({
                      ...prevState,
                      state: true,
                    }))
                  }
                >
                  No Tip
                </div>
                {/* <div className='mt-1' style={{fontSize: 'Max(1.5vw, 1.5vh)'}}>
                    {CUSTOM_MESSAGES().NO_TIP_AMOUNT}
                  </div> */}
                <TipsConfirmPopUp
                  isOpen={showNoTipModal}
                  onClose={() =>
                    setShowNoTipModal(prevState => ({
                      ...prevState,
                      state: false,
                    }))
                  }
                  tipAmount={0}
                  totalAmountForTip={tableData.subTotalAmount.toFixed(2)}
                  onSubmitTips={() => {
                    setTipAmount(0);
                    setShowNoTipModal(prevState => ({
                      ...prevState,
                      state: false,
                    }));
                    !isCounter && selectedPayment !== 'giftCard'
                      ? setPaymentType(23)
                      : handleCheck('tips');
                  }}
                />
              </div>
            )}
            <div className="col-12 text-center mt-2 fs-20">
              {CUSTOM_MESSAGES().NO_TIP_AMOUNT}
            </div>
          </div>
        )}
        <div
          className="col-12"
          style={
            !isCounter
              ? {
                marginTop: ShowLandscapeMode ? '' : '85px',
                position: 'absolute',
                bottom: '110px',
                left: '-5px',
              }
              : {}
          }
        >
          <div
            className="col-12 px-0"
            style={{ position: 'absolute', bottom: isCounter && '2%' }}
          >
            <button
              type="button"
              className={cn(
                'btn btn90 od-btn-primary btn-primary btn-ripple w-100 my-1 col-12'
              )}
              onClick={() => {
                !isCounter && selectedPayment !== 'giftCard'
                  ? validateTipsForCredit()
                  : handleCheck('tips');
              }}
            >
              {isPaymentTerminal ? (
                <span>
                  <div
                    className={cn(
                      isCounter ? 'fs-22' : 'fs-28',
                      style.divForPayment,
                      isPaymentTerminal ? ' m-auto' : ' '
                    )}
                  >
                    {LABEL().TIP_CONTINUE}: {currenySymbol}
                    {tableData &&
                      (
                        tableData.totalAmount -
                        tableData.paidAmount +
                        Number(tipAmount)
                      ).toFixed(2)}
                  </div>
                </span>
              ) : (
                <span>
                  <div
                    className={cn(
                      isCounter ? 'fs-22' : 'fs-28',
                      style.divForPayment,
                      isPaymentTerminal ? ' m-auto' : ' '
                    )}
                    style={{ lineHeight: 1 }}
                  >
                    {LABEL().TIP_CONTINUE}:
                  </div>
                  <div
                    className={cn(
                      'pt-1',
                      isCounter ? 'fs-22' : 'fs-28',
                      style.divForPayment,
                      isPaymentTerminal ? ' m-auto' : ' '
                    )}
                  >
                    {currenySymbol}
                    {tableData &&
                      (
                        tableData.totalAmount -
                        tableData.paidAmount +
                        Number(tipAmount)
                      ).toFixed(2)}
                  </div>
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleBlur = () => {
    const element = document.querySelector(`#${otherAmountName}`);
    element?.blur();
  };

  const onChangePersentage = e => {
    setValue('$0.00');
    const values =
      e !== '{bksp}'
        ? {
          ...inputs,
          [inputName]: inputs[inputName]
            ? inputs[inputName].concat(e)
            : e === '.'
              ? '0.'
              : ''.concat(e),
        }
        : {
          ...inputs,
          [inputName]: inputs[inputName]
            ? inputs[inputName].slice(0, -1)
            : '',
        };

    setInputs({
      ...inputs,
      [inputName]: values[inputName],
    });
    if (values[inputName] === '') {
      setTipvalue('0%' + '');
    } else {
      setTipvalue(values[inputName] + '%');
    }
    onChangeTipPersent(checkboxactive, values[inputName]);
  };

  const handleOtherAmountContinue = () => {
    stopPopUpOtherAmount();
  };

  const checkDecimal = val => {
    const newValdata = val.toString().split('.');
    if (newValdata[1]) {
      const newstr = newValdata[1].substring(0, 1);
      if (Number(newstr) > 0) {
        return Number(val).toFixed(1);
      } else {
        return newValdata[0];
      }
    }
    return val;
  };

  const onClickBtn = e => {
    setTipvalue('0%');
    const values =
      e !== '{bksp}'
        ? {
          ...inputs,
          [inputName]: inputs[inputName]
            ? inputs[inputName].concat(e)
            : e === '.'
              ? '0.'
              : ''.concat(e),
        }
        : {
          ...inputs,
          [inputName]: inputs[inputName]
            ? inputs[inputName].slice(0, -1)
            : '',
        };
    setInputs({
      ...inputs,
      [inputName]: values[inputName],
    });
    if (values[inputName] === '' || values[inputName] === '.') {
      values[inputName] = '0.00';
      setValue(currenySymbol + '0.00');
    } else {
      setValue(currenySymbol + values[inputName]);
    }
    onChangeTipAmount(checkboxactive, values[inputName]);
  };
  const setTotalVisibleVal = val => {
    setTotalVisible(val);
    if (val != totalVisible) {
      setTipvalue('0%');
      setValue(currenySymbol + '0.00');
      setCheckboxactives(false);
    }
    setInputs({
      ...inputs,
      [inputName]: '',
    });
    onChangeTipAmount(checkboxactive, 0);
    onChangeTipPersent(false, 0);
  };

  const handleCheckBox = () => {
    setCheckboxactive(
      !checkboxactive,
      value,
      Number(tipvalue.substring(0, tipvalue.length - 1))
    );
    setCheckboxactives(!checkboxactive);
  };

  const OtherAmount = () => {
    return (
      <div className="col-12 h-100 row mx-0">
        {enableOtherAmount && enableOtherPercent && (
          <div className="col-12 d-flex my-4 justify-content-center h-5">
            <button
              id="btnTotal"
              className={cn(
                'col-5 btn mx-3 btn-ripple btn-lg',
                btnPrimary.isAmount
              )}
              onClick={() => {
                setTotalVisibleVal(true);
                setBtnPrimary({
                  isAmount: 'od-btn-primary btn-primary',
                  isPercent: 'od-btn-secondary',
                });
              }}
            >
              {LABEL().OTHER_AMOUNT}
            </button>
            <button
              id="btnItemisd"
              className={cn(
                'col-5 btn mx-3 btn-ripple btn-lg',
                btnPrimary.isPercent
              )}
              onClick={() => {
                setTotalVisibleVal(false);
                setBtnPrimary({
                  isAmount: 'od-btn-secondary',
                  isPercent: 'od-btn-primary btn-primary',
                });
              }}
            >
              {LABEL().OTHER_PERCENT}
            </button>
          </div>
        )}
        {totalVisible && enableOtherAmount ? (
          <span className="col-12 my-3">
            <input
              className="form-control-lg text-right pl-2 ml-4 w-90 "
              name={otherAmountName}
              value={value}
              onFocus={() => {
                handleBlur();
                setInputName(`${otherAmountName}`);
              }}
              id={otherAmountName}
              placeholder="$"
            />
            <div className={cn('col-12 text-center py-3')}>
              <CustomKeyboard
                onClickBtn={e => onClickBtn(e)}
                type="numericDot"
                isClr
                typed={value}
                btnSize="btn"
                maxLength={100}
                customClass={cn(
                  'fs-30 background-primary od-app-background-color'
                )}
              />
            </div>{' '}
          </span>
        ) : (
          <span className="col-12 my-3">
            <input
              className="form-control-lg text-right pl-2 ml-4 w-90"
              name={otherAmountName}
              value={tipvalue}
              onFocus={() => {
                handleBlur();
              }}
              placeholder="%"
            />
            <div
              className="col-12"
              style={
                isPaymentTerminal ? { fontSize: '14px' } : { fontSize: '18px' }
              }
            ></div>
            <div className={cn('col-12 text-center py-3')}>
              <CustomKeyboard
                onClickBtn={e => onChangePersentage(e)}
                type="numericDot"
                isClr
                typed={tipvalue}
                btnSize="btn"
                maxLength={100}
                customClass={cn(
                  'fs-30 background-primary od-app-background-color'
                )}
              />
            </div>{' '}
          </span>
        )}

        {authInfo?.tipInfo?.useTipToRoundUpTotal ? (
          <div
            className={cn(
              'col-12 fs-20 fw-700 m-0 my-2 od-text-primary ml-3',
              style.divForPayment
            )}
          >
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id="customSwitches"
                checked={checkboxactive}
                onClick={() => {
                  handleCheckBox();
                }}
              />
              <label className="custom-control-label" for="customSwitches">
                Round up my tip{' '}
              </label>
            </div>
          </div>
        ) : null}
        <div className="row">
          <div className="col-12 fs-24 ml-5">
            {' '}
            <label className="col-5">Total Amount </label>{' '}
            <span className="col-6">
              {currenySymbol}
              {Number(tableData.totalAmount).toFixed(2)}
            </span>{' '}
          </div>
          <div className="col-12 fs-24 ml-5">
            {' '}
            <label className="col-5">Tip Amount </label>{' '}
            <span className="col-6">
              {' '}
              {currenySymbol}
              {Number(tipAmount === '.' ? 0 : tipAmount).toFixed(2)}{' '}
            </span>{' '}
          </div>
          <div className="col-12 fs-24 ml-5">
            {' '}
            <label className="col-5">Tip Percent </label>{' '}
            <span className="col-6">
              {' '}
              {checkDecimal(((100 * tipAmount) / totalAmountForTip).toFixed(1))}
              %{' '}
            </span>{' '}
          </div>
        </div>
        <div
          className="col-12"
          style={
            isPaymentTerminal ? { fontSize: '14px' } : { fontSize: '18px' }
          }
        >
          {CUSTOM_MESSAGES().Suggested_tip_is_calculated_on_check_disclaimer}
        </div>
        <div
          className="col-12"
          style={!isCounter ? { marginTop: '', left: '-5px' } : {}}
        >
          <button
            type="button"
            className={cn(
              'btn btn90 od-btn-primary btn-primary btn-ripple w-100 my-1 col-12'
            )}
            onClick={() => handleOtherAmountContinue()}
          >
            {isPaymentTerminal ? (
              <span>
                <div
                  className={cn(
                    'fs-28',
                    style.divForPayment,
                    isPaymentTerminal ? ' m-auto' : ' '
                  )}
                >
                  {LABEL().TIP_CONTINUE}: {currenySymbol}
                  {tableData &&
                    (
                      tableData.totalAmount -
                      tableData.paidAmount +
                      Number(tipAmount)
                    ).toFixed(2)}
                </div>
              </span>
            ) : (
              <span>
                <div
                  className={cn(
                    'fs-28',
                    style.divForPayment,
                    isPaymentTerminal ? ' m-auto' : ' '
                  )}
                  style={{ lineHeight: '1' }}
                >
                  {LABEL().TIP_CONTINUE}:
                </div>
                <div
                  className={cn(
                    'fs-28 pt-1',
                    style.divForPayment,
                    isPaymentTerminal ? ' m-auto' : ' '
                  )}
                >
                  {currenySymbol}
                  {tableData &&
                    (
                      tableData.totalAmount -
                      tableData.paidAmount +
                      Number(tipAmount)
                    ).toFixed(2)}
                </div>
              </span>
            )}
          </button>
        </div>
      </div>
    );
  };

  const syncDataMisMatch = () => {
    return (
      <div className="col-12 h-100 row mx-0">
        <div
          className="align-items-center m-auto h-80"
          style={{ color: 'red' }}
        >
          <div
            className="d-flex justify-content-around mb-2"
            style={{ marginTop: '20%' }}
          >
            <i
              className="fas fa-exclamation-circle"
              style={{ fontSize: '80px' }}
            />
          </div>
          <div
            className=" fw-600 d-flex justify-content-around text-center"
            style={{ fontSize: '2rem', marginTop: '20%' }}
          >
            {LABEL().CHECK_MEG}
          </div>
          <div className="col-12 fs-24 fw-600 d-flex justify-content-around mt-5 text-center">
            <div className="col-10" style={{ fontSize: '1.5rem' }}>
              {LABEL().CHECK_SERVER}
            </div>
          </div>
        </div>

        {isDone && (
          <button
            type="button"
            className="btn btn90 od-btn-primary btn-primary btn-ripple w-100"
            onClick={() => handleRouteCheck()}
            style={{
              marginTop: !isCounter && isPaymentTerminal ? '3rem' : '0rem',
            }}
          >
            <div
              className={cn(style.divForPayment)}
              style={{ fontSize: isServerApp ? '2rem' : '20px' }}
            >
              {LABEL().DONE}
            </div>
          </button>
        )}
      </div>
    );
  };
  const partialPaymentError = () => {
    return (
      <div className="col-12 h-100 row mx-0">
        <div
          className="align-items-center m-auto h-80"
          style={{ color: 'red' }}
        >
          <div
            className="d-flex justify-content-around mb-2"
            style={{ marginTop: '10%' }}
          >
            <i
              className="fas fa-exclamation-circle"
              style={{ fontSize: '80px' }}
            />
          </div>
          <div
            className=" fw-600 d-flex justify-content-around text-center"
            style={{ fontSize: '2rem', marginTop: '15%' }}
          >
            {LABEL().PAYMENT_MEG}
          </div>
          <div className="col-12 fs-24 fw-600 d-flex justify-content-around  mt-5 text-center">
            <div className="col-10" style={{ fontSize: '1.5rem' }}>
              {LABEL().PAYMENT_SERVER}
            </div>
          </div>
          <div className="mt-5">
            <div className="fs-28 fw-600 d-flex justify-content-start m-2 ml-5">
              Payment Amount:{' '}
              {`${LABEL().CURRENCY_SYMBOL}${partialPayment.totalAmount}`}
            </div>
            <div className="fs-28 fw-600 d-flex justify-content-start m-2 ml-5">
              Approved Amount:{' '}
              {`${LABEL().CURRENCY_SYMBOL}${partialPayment.ticketAmount}`}
            </div>
            <div className="fs-28 fw-600 d-flex justify-content-start m-2 ml-5">
              Balance Amount:{' '}
              {`${LABEL().CURRENCY_SYMBOL}${Math.abs(
                partialPayment.balanceAmount
              )}`}
            </div>
          </div>
        </div>
        {isDone && (
          <button
            type="button"
            className="btn btn90 od-btn-primary btn-primary btn-ripple w-100"
            onClick={() => handleRouteCheck()}
            style={{
              marginTop: !isCounter && isPaymentTerminal ? '3rem' : '0rem',
            }}
          >
            <div
              className={cn(style.divForPayment)}
              style={{ fontSize: isServerApp ? '2rem' : '20px' }}
            >
              {LABEL().DONE}
            </div>
          </button>
        )}
      </div>
    );
  };
  const getStatus = status => {
    switch (status) {
      case 0:
        return 'Pending';
      case 3:
        return 'Swiped';
      case 5:
        return 'Complete';
      case 9:
        return 'Error';
    }
  };

  const giftCardReceiptTile = (item, index) => {
    return (
      <div
        className="d-flex flex-column my-4 p-2 fs-20 fw-600"
        style={{ border: '2px solid black' }}
      >
        <div className="d-flex justify-content-between">
          <span>{item?.name}</span>
          <span>{LABEL().CURRENCY_SYMBOL + item.amount.toFixed(2)}</span>
          <span>{item?.number}</span>
        </div>
        <div>
          <span className="mr-1">Status:</span>
          <span>{getStatus(item?.status)}</span>
        </div>
        <div className="pb-2">
          <span className="mr-1">Message:</span>
          <span>{item?.message ? item?.message : 'NA'}</span>
        </div>
        <div className="d-flex justify-content-center">
          {item?.status === 9 && (
            <button
              type="button"
              className={cn(
                'btn btn10 px-4 mx-0 od-btn-primary btn-primary btn-ripple my-2 p-2 '
              )}
              onClick={() => {
                swipeGiftCard(item);
              }}
            >
              Swipe
            </button>
          )}
        </div>
      </div>
    );
  };

  const giftCardReceipt = () => {
    return (
      <div className="m-10 py-1">
        <div className="text-center fs-20 fw-600">
          {LABEL().GIFT_CARD_ACTIVATION_MESSAGE}
        </div>
        <div className="d-flex justify-content-around">
          {isServerApp && (
            <div className=" p-2">
              <button
                type="button"
                className={cn(
                  'btn btn80 px-1 mx-0 od-btn-primary btn-primary btn-ripple my-2 p-2 '
                )}
                onClick={() => handleReceiptPopUpOpen('phone')}
              >
                <div
                  className={cn(
                    'text-uppercase',
                    style.divForPayment,
                    isPaymentTerminal ? 'fs-22' : 'fs-30'
                  )}
                >
                  {LABEL().PAY_TEXT_RECEIPT}
                </div>
              </button>
            </div>
          )}
          {isServerApp && (
            <div className=" p-2">
              <button
                type="button"
                className={cn(
                  'btn btn80 px-1 mx-0 od-btn-primary btn-primary btn-ripple my-2 p-2'
                )}
                onClick={() => handleReceiptPopUpOpen('email')}
              >
                <div
                  className={cn(
                    'text-uppercase',
                    style.divForPayment,
                    isPaymentTerminal ? 'fs-22' : 'fs-30'
                  )}
                >
                  {LABEL().PAY_EMAIL_RECEIPT}
                </div>
              </button>
            </div>
          )}

          {isServerApp && (
            <div className=" p-2">
              <button
                type="button"
                className={cn(
                  'btn btn80 px-1 mx-0 od-btn-primary btn-primary btn-ripple my-2'
                )}
                onClick={() => handleCheck('print')}
              >
                <div
                  className={cn(
                    'text-uppercase',
                    style.divForPayment,
                    isPaymentTerminal ? 'fs-22' : 'fs-30'
                  )}
                >
                  {LABEL().PAY_PRINT_RECEIPT}
                </div>
              </button>
            </div>
          )}
        </div>
        <div
          className="col-11 mx-auto justify-content-center overflowY"
          style={{ marginTop: '10px', overflow: 'scroll', height: '60vh' }}
        >
          {JSON.parse(window.sessionStorage.getItem('cards'))
            ?.filter(el => el.type === 2)
            ?.map((item, index) => giftCardReceiptTile(item, index))}
        </div>
        <div style={{ paddingRight: '25%', paddingLeft: '25%' }}>
          <button
            type="button"
            className={cn(
              'btn btn90 fs-25 fw-700 od-btn-primary btn-primary btn-ripple w-100'
            )}
            onClick={() => continueGiftCardPayment()}
          >
            <div
              className={cn('text-uppercase', style.divForPayment)}
              style={{ fontSize: isServerApp ? '2rem' : '20px' }}
            >
              {LABEL().CONTINUE}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const Charity = () => {
    return (
      <div className="col-12 h-100 row mx-0">
        <div className="col-12 h-80 mb-1">
          <div className="fs-26 h-15 od-text-primary mb-1 text-center">
            {charity.name}
          </div>
          <div className="col-12 h-50 mb-1 text-center">
            <img src={charity.imageUrl} alt="" className="h-100" />
          </div>
          <div className="h-30 mb-2 col-12 p-0 overflowY">
            {charity.description}
          </div>
        </div>
        <div className="col-12 h-25 p-0">
          {charityList && charityList.length > 0 ? (
            <div className="col-12 od-text-primary fs-20 text-center p-0">
              <div className={style.charityWrapper}>
                {charityList.map(item => {
                  return (
                    <div
                      key={item.key}
                      role="presentation"
                      onClick={() => {
                        handleKeyboardValue('');
                        handleButtonClick(item.displayKey);
                      }}
                      className={cn(
                        'border rounded border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center',
                        item.displayKey === active
                          ? 'bg-grey color-white od-btn-secondary'
                          : ''
                      )}
                    >
                      <div>{item.displayKey}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
        <div className="col-12 h-30 flex-column p-0 d-flex justify-content-end py-2">
          <button
            type="button"
            className="btn rounded od-btn-primary btn-primary btn-ripple w-100 my-1"
            onClick={() => applyDonation()}
          >
            <div className="fs-18">{LABEL().APPLY_DONATION}</div>
          </button>
          <button
            type="button"
            className="btn rounded od-btn-primary btn-primary btn-ripple w-100 my-1"
            onClick={() => handleTipsRouteTo()}
          >
            <div className="fs-18">{LABEL().SKIP_DONATION}</div>
          </button>
        </div>
      </div>
    );
  };

  const PaymentRecipt = () => {
    return (
      <div
        className="col-12 h-95 row mx-0 justify-content-center align-items-end pt-2 od-text-primary text-primary"
        style={{ position: 'fixed', width: '90%' }}
      >
        {themeProperties?.serverAppLogoImageUrl && (
          <div
            className="col-12 py-2 row mx-0 align-items-center"
            style={!isCounter ? { top: '3px', position: 'absolute' } : {}}
          >
            <img
              src={themeProperties.serverAppLogoImageUrl}
              alt=""
              className="img-fluid mx-auto d-block h-100"
              style={{
                maxHeight: '250px',
              }}
            />
          </div>
        )}
        <div
          className={cn(
            'col-12 row justify-content-center align-items-center p-0 text-center fs-22 fw-600',
            style.divForPayment
          )}
          style={!isCounter ? { top: '77px' } : {}}
        >
          {LABEL().PAYMENT_RECEIPT}
        </div>
        <div className="col-12 p-0 ">
          {(((isServerApp || isPaymentTerminal) && receiptTypes?.sms) ||
            isTableTop) && (
              <button
                type="button"
                className={cn(
                  'btn od-btn-primary btn-primary btn-ripple my-2 w-100 text-uppercase '
                )}
                onClick={() => handleReceiptPopUpOpen('phone')}
              >
                <div className={cn('fs-18', style.divForPayment)}>
                  {LABEL().TEXT}
                </div>
              </button>
            )}
          {(((isServerApp || isPaymentTerminal) && receiptTypes?.email) ||
            isTableTop) && (
              <button
                type="button"
                className={cn(
                  'btn od-btn-primary btn-primary btn-ripple my-2 w-100 text-uppercase '
                )}
                onClick={() => handleReceiptPopUpOpen('email')}
              >
                <div className={cn('fs-18', style.divForPayment)}>
                  {LABEL().EMAIL}
                </div>
              </button>
            )}
          {(((isServerApp || isPaymentTerminal) && receiptTypes?.print) ||
            isTableTop) && (
              <button
                type="button"
                className="btn od-btn-primary btn-primary btn-ripple my-2 w-100 "
                onClick={() => handleCheck('print')}
              >
                <div
                  className={cn('fs-18', style.divForPayment)}
                  style={{ textTransform: 'uppercase' }}
                >
                  {LABEL().PRINT}
                </div>
              </button>
            )}
          <button
            type="button"
            className={cn(
              'btn od-btn-primary btn-primary btn-ripple mt-2 w-100 '
            )}
            onClick={() => handleCheck('receipt')}
          >
            <div className={cn('fs-18', style.divForPayment)}>
              {LABEL().NO_RECEIPT_OPTION}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const confirmationAndReceiptScreen = () => {
    return (
      <div className="col-12 row mx-0 justify-content-center">
        <div
          className="col-12 row px-0 justify-content-center my-4"
          style={{ lineHeight: '1' }}
        >
          <div
            className={cn(
              'col-12 row justify-content-center px-0 lh-1 fw-600',
              style.divForPayment,
              isPaymentTerminal
                ? 'fs-22'
                : ShowLandscapeMode
                  ? 'fs-18'
                  : 'fs-30'
            )}
          >
            {LABEL().APPROVED}: {'$'}
            {`${Number(authResponse?.ticket?.totalTicketAmount).toFixed(
              2
            )} was paid via`}
          </div>
          <div
            className={cn(
              'col-12 row justify-content-center mx-0 align-items-center py-1 text-center fw-700 od-text-primary text-primary lh-1 fw-600',
              style.divForPayment,
              isPaymentTerminal
                ? 'fs-22'
                : ShowLandscapeMode
                  ? '1.5rem'
                  : 'fs-30'
            )}
          >
            {authResponse?.ticket &&
              authResponse.ticket?.ticketPaymentTypeName === 'CreditCard' &&
              `${authResponse.ticket.cardType} ending with ${authResponse.ticket.cardLast4 === null
                ? ''
                : authResponse.ticket.cardLast4.slice(-4)
              }`}
            {authResponse?.ticket?.ticketPaymentTypeName === 'GiftCard' &&
              `${authResponse.ticket.cardType === null
                ? ''
                : authResponse.ticket.cardType
              } ending with ${authResponse.ticket.cardLast4 === null
                ? ''
                : authResponse.ticket.cardLast4.slice(-4)
              }`}
            {authResponse?.ticket?.ticketPaymentTypeName === 'Cash' &&
              `${authResponse.ticket.ticketPaymentTypeName}`}
          </div>
        </div>
        <div
          className="col-12 row p-0 flex-row justify-content-between"
          style={{
            height: isServerApp ? '19vh' : '',
            zIndex: 1,
          }}
        >
          {!smsEmailPrintObject.NoReceipt &&
            !smsEmailPrintObject.smsReceiptStatus &&
            !smsEmailPrintObject.emailReceiptStatus &&
            !smsEmailPrintObject.printReceiptStatus ? (
            <>
              {(((isServerApp || isPaymentTerminal) && receiptTypes?.sms) ||
                isTableTop) && (
                  <div
                    className={cn(
                      buttonAllignment(),
                      isPaymentTerminal ? 'mx-0 px-1' : ''
                    )}
                  >
                    <button
                      type="button"
                      className={cn(
                        'btn btn80 px-1 mx-0 od-btn-primary btn-primary btn-ripple my-2 col-12'
                      )}
                      onClick={() => handleReceiptPopUpOpen('phone')}
                    >
                      <div
                        className={cn(
                          'text-uppercase',
                          style.divForPayment,
                          isPaymentTerminal ? 'fs-22' : 'fs-30'
                        )}
                      >
                        {LABEL().PAY_TEXT_RECEIPT}
                      </div>
                    </button>
                  </div>
                )}
              {(((isServerApp || isPaymentTerminal) && receiptTypes?.email) ||
                isTableTop) && (
                  <div
                    className={cn(
                      buttonAllignment(),
                      isPaymentTerminal ? 'mx-0 px-1' : ''
                    )}
                  >
                    <button
                      type="button"
                      className={cn(
                        'btn btn80 px-1 mx-0 od-btn-primary btn-primary btn-ripple my-2 col-12'
                      )}
                      onClick={() => handleReceiptPopUpOpen('email')}
                    >
                      <div
                        className={cn(
                          'text-uppercase',
                          style.divForPayment,
                          isPaymentTerminal ? 'fs-22' : 'fs-30'
                        )}
                      >
                        {LABEL().PAY_EMAIL_RECEIPT}
                      </div>
                    </button>
                  </div>
                )}

              {(((isServerApp || isPaymentTerminal) && receiptTypes?.print) ||
                isTableTop) && (
                  <div
                    className={cn(
                      buttonAllignment(),
                      isPaymentTerminal ? 'mx-0 px-1' : ''
                    )}
                  >
                    <button
                      type="button"
                      className={cn(
                        'btn btn80 px-1 mx-0 od-btn-primary btn-primary btn-ripple my-2 col-12'
                      )}
                      onClick={() => handleCheck('print')}
                    >
                      <div
                        className={cn(
                          'text-uppercase',
                          style.divForPayment,
                          isPaymentTerminal ? 'fs-22' : 'fs-30'
                        )}
                      >
                        {LABEL().PAY_PRINT_RECEIPT}
                      </div>
                    </button>
                  </div>
                )}
              {(((isServerApp || isPaymentTerminal) &&
                (receiptTypes?.sms ||
                  receiptTypes?.email ||
                  receiptTypes?.print)) ||
                isTableTop) && (
                  <div
                    onClick={handleNoReceipt}
                    className={cn(
                      isKiosk ? 'fs-30' : 'fs-18',
                      'col-12 row mx-0 text-center justify-content-center align-items-center'
                    )}
                    style={{
                      textDecorationLine: 'underline',
                      fontWeight: 'bold',
                    }}
                  >
                    {' '}
                    {LABEL().RS_NO_RECEIPT}
                  </div>
                )}
            </>
          ) : (
            <>
              <div
                className={cn(
                  'col-12 row mx-0 text-center od-text-primary text primary justify-content-center align-items-center',
                  style.divForPayment
                )}
                style={{ fontSize: isPaymentTerminal ? '1.8rem' : '3rem' }}
              >
                {' '}
                {LABEL().RS_YOU_ARE_ALL_DONE}{' '}
              </div>
              <div
                onClick={handleReceiptType}
                className={cn(
                  isKiosk ? 'fs-30' : 'fs-18',
                  'col-12 row mx-0 text-center justify-content-center align-items-center'
                )}
                style={{ textDecorationLine: 'underline', fontWeight: 'bold' }}
              >
                {' '}
                {LABEL().RS_NEED_A_RECEIPT}
              </div>{' '}
            </>
          )}
        </div>

        <div className={cn('col-12 row px-0 text-center h-60')}>
          {Number(unpaidAmount) <= 0 ? (
            <>
              <div
                className={cn(
                  'mx-0 row align-items-end col-12 justify-content-center text-center'
                )}
              >
                <img
                  src={tick}
                  alt="fullimage"
                  className={cn(
                    'img-responsive center',
                    isCounter ? 'w-10' : ' w-25'
                  )}
                />
              </div>

              <div
                className={cn(
                  'col-12 row mx-0 text-center od-text-primary text primary justify-content-center align-items-center',
                  style.divForPayment
                )}
                style={{
                  fontSize: isPaymentTerminal
                    ? '25px'
                    : ShowLandscapeMode
                      ? '1.5rem'
                      : '3rem',
                }}
              >
                {' '}
                {CUSTOM_MESSAGES().PAYMENT_COMPLETE}
              </div>
              <div className="col-12 row mx-0 my-3 justify-content-center">
                <div
                  className={cn(
                    'col-12 row text-center justify-content-center align-items-end fw-700 od-text-primary text-primary',
                    style.divForPayment,
                    isPaymentTerminal ? 'px-0' : ''
                  )}
                  style={{
                    fontSize: isServerApp
                      ? ShowLandscapeMode
                        ? '1.5rem'
                        : '2rem'
                      : '20px',
                  }}
                >
                  {CUSTOM_MESSAGES().GREAT_SERVING_YOU}
                </div>
                <div
                  className={cn(
                    'col-12 row text-center justify-content-center fw-700 od-text-primary text-primary',
                    style.divForPayment,
                    isPaymentTerminal ? 'px-0' : ''
                  )}
                  style={{
                    fontSize: isServerApp
                      ? ShowLandscapeMode
                        ? '1.5rem'
                        : '2rem'
                      : '20px',
                  }}
                >
                  {CUSTOM_MESSAGES().COME_BACK_SOON}
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                className={cn(
                  isPaymentTerminal
                    ? 'h-30 mx-0 mt-5 row align-items-end col-12 justify-content-center text-center'
                    : 'h-40 mx-0 row align-items-end col-12 justify-content-center text-center'
                )}
              >
                <img
                  src={handOff}
                  alt="fullimage"
                  className={cn(
                    'img-responsive center',
                    isPaymentTerminal ? 'w-90' : 'w-85'
                  )}
                />
              </div>
              <div
                className={cn(
                  'col-12 py-1 text-center fw-700 od-text-primary text-primary justify-content-between align-items-end',
                  style.divForPayment,
                  isPaymentTerminal
                    ? 'mx-0 px-1 justify-content-center align-items-end mt-2 fs-22'
                    : 'fs-28 my-3'
                )}
              >
                <div style={{ fontSize: isServerApp ? '2rem' : '1.8rem' }}>
                  {LABEL().TOTAL_REMAINING}
                </div>
                <div style={{ fontSize: '20vw' }}>
                  {LABEL().CURRENCY_SYMBOL +
                    amountToshow.unpaidAmount.toFixed(2)}
                </div>
              </div>
            </>
          )}
          {Number(unpaidAmount) > 0 && (
            <button
              type="button"
              className={cn(
                'btn btn90 fs-25 fw-700 od-btn-primary btn-primary btn-ripple my-1 w-100'
              )}
              onClick={() => handleRouteCheck()}
            >
              <div
                className={cn('text-uppercase', style.divForPayment)}
                style={{ fontSize: isServerApp ? '2rem' : '20px' }}
              >
                {LABEL().CONTINUE_TO_GUEST}
              </div>
            </button>
          )}
          {isDone && Number(unpaidAmount) === 0 && (
            <button
              type="button"
              className="btn btn90 od-btn-primary btn-primary btn-ripple w-100"
              onClick={() => handleRouteCheck()}
              style={{
                marginTop: isCounter ? '' : isPaymentTerminal ? '3rem' : '0rem',
              }}
            >
              <div
                className={cn(style.divForPayment)}
                style={{ fontSize: isServerApp ? '2rem' : '20px' }}
              >
                {LABEL().DONE}
              </div>
            </button>
          )}
        </div>
      </div>
    );
  };

  const PaymentConfirmationSuccess = () => {
    return (
      <div className={cn('col-12 w-100', isPaymentTerminal ? 'h-80' : 'h-75')}>
        <div className="col-12 p-0 h-40 row mx-0 justify-content-center align-items-end">
          <div className="col-12 py-2 h-100 row mx-0 align-items-center">
            <img
              src={getConfirmationLogo()}
              alt=""
              className="img-fluid mx-auto d-block h-100"
              style={{
                minHeight: '200px',
                maxHeight: '350px',
              }}
            />
          </div>
        </div>
        <div
          className={cn(
            isPaymentTerminal
              ? 'h-20 mx-0 row align-items-end col-12 justify-content-center text-center'
              : 'h-35 mx-0 row align-items-end col-12 justify-content-center text-center'
          )}
        >
          <img
            src={tick}
            alt="fullimage"
            className="img-responsive center w-40"
          />
        </div>
        <div className="col-12 p-0 h-20 row text-center mx-0 justify-content-center align-items-end py-2">
          {isDone && Number(unpaidAmount) === 0 && (
            <button
              type="button"
              className="btn rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
              onClick={() => handleRouteCheck()}
            >
              <div className="fs-18">{LABEL().DONE}</div>
            </button>
          )}
          <div
            className={cn(
              'mb-2 fs-28 fw-100 od-text-primary text-primary text-uppercase',
              style.divForPayment
            )}
          >
            {LABEL().PAYMENT_NOW_COMPLETE}
          </div>
        </div>
        <div
          className={cn(
            'col-12 row justify-content-center mx-0 align-items-end py-1 text-center fs-15 fw-700 od-text-primary text-primary',
            style.divForPayment
          )}
        >
          {authResponse?.ticket?.ticketPaymentTypeName === 'CreditCard' &&
            `Paid With ${authResponse.ticket.cardType
            } ending with ${authResponse.ticket.cardLast4.slice(-4)}`}
          {authResponse?.ticket?.ticketPaymentTypeName === 'GiftCard' &&
            `Paid With ${authResponse.ticket.cardType
            } ending with ${authResponse.ticket.cardLast4.slice(-4)}`}
          {authResponse?.ticket?.ticketPaymentTypeName === 'Cash' &&
            `Paid With ${authResponse.ticket.ticketPaymentTypeName}`}
        </div>

        <div
          className={cn(
            'col-12 row m-0 align-items-end',
            isPaymentTerminal ? 'h-30' : 'h-35'
          )}
        >
          <div className="col-12 row m-0 align-items-center text-center">
            {Number(unpaidAmount) <= 0 ? (
              <>
                <div
                  className={cn(
                    'col-12 py-2 text-center fs-26 fw-700 od-text-primary text-primary',
                    style.divForPayment
                  )}
                >
                  {CUSTOM_MESSAGES().GREAT_SERVING_YOU}
                </div>
                <div
                  className={cn(
                    'col-12 py-4 text-center fs-26 fw-700 od-text-primary text-primary',
                    style.divForPayment
                  )}
                >
                  {CUSTOM_MESSAGES().COME_BACK_SOON}
                </div>
              </>
            ) : (
              <div
                className={cn(
                  'col-12 py-1 text-center fs-26 fw-700 od-text-primary text-primary text-uppercase',
                  style.divForPayment
                )}
              >
                {CUSTOM_MESSAGES().CONTINUE_PAY_REMAINING_BALANCE}
              </div>
            )}
            {/* <div className="col-12">
            <img
              src={tick}
              alt="fullimage"
              className="img-responsive center"
            />
            <div className="mb-2 fs-18 od-text-primary text-primary">
              {successMessage || `${LABEL().PAYMENT_NOW_COMPLETE}. Paid with ${authResponse && authResponse.ticket && authResponse.ticket.ticketPaymentTypeName.replace(/([A-Z])/g, ' $1').toUpperCase()}`}
            </div>
          </div> */}
            {Number(unpaidAmount) > 0 && (
              <button
                type="button"
                className="btn fs-25 fw-700 od-btn-primary btn-primary btn-ripple my-1 w-100"
                onClick={() => handleRouteCheck()}
              >
                <div className={cn('fs-18', style.divForPayment)}>
                  {LABEL().CONTINUE}
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };
  const renderModifier = modifiersObj =>
    (modifiersObj || []).map(modifier => (
      <div
        key={modifier.modifierId}
        className={
          modifier.price
            ? 'col-12 text-left p-0 fs-18'
            : isCallCenter
              ? 'col-12 text-left p-0 fs-18'
              : 'd-none'
        }
      >
        {`${modifier.quantity > 1 ? `- ${modifier.quantity} x ` : '- '} ${modifier.modifierName
          } ${modifier.price ? `(${currenySymbol}${modifier.price.toFixed(2)})` : ''
          }`}
        {(modifier.note || modifier.comment) && (
          <div className="pl-2">{modifier.note || modifier.comment}</div>
        )}
        {modifier.modifiers && modifier.modifiers.length > 0 && (
          <div className="pl-2">{renderModifier(modifier.modifiers)}</div>
        )}
      </div>
    ));
  const excludeItemFromReceiptScreen = item => {
    let excludeProduct = false;
    allMenuItems?.forEach(insideItems => {
      if (
        insideItems.id === item.menuItemId &&
        insideItems?.excludeFromReceipt
      ) {
        excludeProduct = true;
      }
    });
    return excludeProduct;
  };
  const PaymentCallCenterConfirmationSuccess = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 px-0">
        <div className="col-8 h-100 w-100">
          {tableData.items && tableData.items.length > 0 && (
            <div
              className={cn(
                'col-12 pt-4 w-100 border-bottom border-color-primary od-text-primary text-primary overflowY',
                isTableTop ||
                  isKiosk ||
                  ShowLandscapeMode ||
                  isPaymentTerminal ||
                  [23].includes(paymentType)
                  ? 'h-60 p-2'
                  : 'h-80 p-2',
                { 'px-2 pt-4 pb-2': isTableTop && !noRoundedBorder }
              )}
            >
              {tableData?.items?.map(item => {
                const excludeFromReceipt = excludeItemFromReceiptScreen(item);
                return (
                  <>
                    {!excludeFromReceipt && (
                      <div key={item.menuItemId} className="row m-0">
                        <div className="col-9 p-0 text-left fs-18">
                          <div className="row mx-0">
                            <span
                              className={cn(
                                'col-10 p-0 fs-16 fw-700',
                                item.quantity > 1 || tableData.splitValue > 1
                                  ? 'col-4'
                                  : ''
                              )}
                            >
                              {item.quantity > 1 && item.quantity + 'x '}{' '}
                              {item.menuItemName}
                            </span>
                          </div>
                        </div>
                        <div
                          className={cn(
                            'col-3 p-0  fs-18 text-right',
                            style.divForPayment
                          )}
                        >
                          {currenySymbol}
                          {item.price.toFixed(2)}
                        </div>
                        <div className="col-12 p-0">
                          {item.modifiers && renderModifier(item.modifiers)}
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          )}
          <div className="row mx-0 fw-700 fs-18">
            <div className={cn('col-6 p-0 text-left', style.divForPayment)}>
              {LABEL().SUB_TOTAL}
            </div>
            <div className={cn('col-6 p-0 text-right', style.divForPayment)}>
              {currenySymbol}
              {(tableData.subTotalAmount || tableData.subTotalAmount === 0) &&
                tableData.subTotalAmount.toFixed(2)}
            </div>
          </div>
          <div className="row mx-0 fw-700 fs-18">
            <div className={cn('col-6 p-0 text-left', style.divForPayment)}>
              {countryCode === '44' ? LABEL().VAT : LABEL().TAX}
            </div>
            <div className={cn('col-6 p-0 text-right', style.divForPayment)}>
              {currenySymbol}
              {(tableData.taxAmount || tableData.taxAmount === 0) &&
                tableData.taxAmount.toFixed(2)}
            </div>
          </div>
          <div className="row mx-0 fw-700 fs-18 align-items-center">
            <div
              className={cn('col-6 p-0 text-left fs-30', style.divForPayment)}
            >
              {LABEL().PAYEMENT_TOTAL_DUE}
            </div>
            <div
              className={cn(
                isKiosk ||
                  isTableTop ||
                  deviceInfo?.deviceGroup?.startMode === 0
                  ? 'col-6 p-0 text-right fs-30'
                  : 'col-6 p-0 text-right',
                style.divForPayment
              )}
            >
              {currenySymbol}
              {(tableData.totalAmount || tableData.totalAmount === 0) &&
                tableData.totalAmount.toFixed(2)}
            </div>
          </div>
          {getObjectValue(() => tableData.paidAmount > 0, false) && (
            <div className="row m-0 fw-700 fs-18">
              <div className={cn('col-6 p-0 text-left', style.divForPayment)}>
                {LABEL().TOTAL_PAID}
              </div>
              <div className={cn('col-6 p-0 text-right', style.divForPayment)}>
                {currenySymbol}
                {tableData.paidAmount.toFixed(2)}
              </div>
            </div>
          )}
        </div>
        <div className="col px-0 h-100 w-100 border-left border-color-primary">
          <div className="col-12 h-100 w-100 px-0">
            <div className="col-12 p-0 h-100 row mx-0 justify-content-center align-items-end">
              {getConfirmationLogo() !== null && (
                <div className="h-auto align-items-center">
                  <img
                    src={getConfirmationLogo()}
                    alt=""
                    className="img-fluid mx-auto d-block h-100"
                    style={{
                      minHeight: '200px',
                      maxHeight: '350px',
                    }}
                  />
                </div>
              )}
              <div>
                <div>
                  <div className="col-12 py-1 text-center fs-20 h-10 od-text-primary text-primary">
                    {CUSTOM_MESSAGES().GREAT_SERVING_YOU}
                    <div>Come back to see us again soon</div>
                  </div>
                  <div className="col-12 mt-20 mb-20 d-flex align-items-center justify-content-center">
                    <img
                      src={tick}
                      alt="fullimage"
                      className="img-responsive center"
                    />
                  </div>
                </div>
                <div className="py-1 mt-20 fs-20 h-10 od-text-primary align-items-center justify-content-center text-center">
                  <div>Name: {callCenterModeUserInfo?.name}</div>
                  <div>Phone Number: {callCenterModeUserInfo?.phoneNumber}</div>
                  <div>Pickup Time: {callCenterModeUserInfo?.pickupTime}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const PaymentConfirmationError = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-end py-2 od-text-primary text-primary">
        <div className="col-12 fs-26 p-0 text-center">
          {CUSTOM_MESSAGES().PAYMENT_PROCESSING_ERROR}
        </div>
        <div className="col-12 p-0">
          <button
            type="button"
            className="btn rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
            onClick={() => handleRouteCheck()}
          >
            <div className="fs-18">{LABEL().DONE}</div>
          </button>
        </div>
      </div>
    );
  };

  const PaymentCallCenterConfirmationError = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-end py-2 od-text-primary text-primary">
        <div className="col-12 fs-26 p-0 text-center">
          Your order has been canceled
        </div>
        <img
          src={CancelIcon}
          alt=""
          className="img-fluid mx-auto d-block h-100"
          style={{
            minHeight: '90px',
            maxHeight: '90px',
            maxWidth: '177px',
          }}
        />
        <div className="col-12 p-0"></div>
      </div>
    );
  };

  const PaymentErrorRetry = () => {
    return (
      <div className="col-12 w-100 row mx-0 justify-content-center align-items-end py-2 od-text-primary text-primary">
        <div className="col-12 fs-26 p-0 text-center"></div>
        <div
          className="col-12 d-flex align-items-end p-0 flex-column justify-content-end"
          style={{
            marginBottom: isPaymentTerminal ? '80px' : '',
          }}
        >
          {isCounter && (
            <button
              type="button"
              className="btn rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
              onClick={() => handleChangePaymentType()}
            >
              <div className="fs-18">{LABEL().CHANGE_PAYMENT_TYPE}</div>
            </button>
          )}
          <button
            type="button"
            className="btn rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
            onClick={() => handleRetry()}
          >
            <div style={{ fontSize: isServerApp ? '2rem' : '20px' }}>
              {LABEL().RETRY}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const PaymentErrorRetryPreAuth = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-end py-2 od-text-primary text-primary">
        <div className="col-12 fs-26 p-0 text-center"></div>
        <div className="col-12 h-30 d-flex align-items-end p-0 flex-column justify-content-end">
          {isCounter && (
            <button
              type="button"
              className="btn rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
              onClick={() => handleChangePaymentType()}
            >
              <div style={{ fontSize: isServerApp ? '2rem' : '20px' }}>
                {LABEL().CHANGE_PAYMENT_TYPE}
              </div>
            </button>
          )}
          <button
            type="button"
            className="btn rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
            onClick={() => preAuthFunctionCall()}
          >
            <div style={{ fontSize: isServerApp ? '2rem' : '20px' }}>
              {LABEL().RETRY}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const SplitEvenly = () => {
    const [count, setCount] = useState(2);
    return (
      <div className="col-12 h-100">
        <div
          className={cn('col-10 h-20 m-auto text-center', style.divForPayment)}
          style={{ fontSize: isServerApp ? '2rem' : '20px' }}
        >
          {LABEL().HOW_MANY_WILL_BE_SPLITTING
            ? LABEL().HOW_MANY_WILL_BE_SPLITTING
            : CUSTOM_MESSAGES().SPLITTING_MESSAGE}
        </div>
        <div
          className={cn(
            'col-12 h-60',
            ShowLandscapeMode ? 'p-0' : style.padding10
          )}
        >
          <div className="row align-items-center h-100 justify-content-center">
            <button
              className={cn(
                style.incDecButton,
                style.btnRounded,
                'mx-4 btn-secondary od-dec-font-btn-color od-dec-counter-btn-color'
              )}
              style={{ fontSize: isServerApp ? '2rem' : '20px' }}
              onClick={() => count !== 2 && setCount(count - 1)}
            >
              <i className="fas fa-minus justify-content-center align-items-center fs-50" />
            </button>
            <div
              className={cn(
                'text-primary od-text-primary',
                style.divForPayment
              )}
              style={{ fontSize: '3rem' }}
            >
              {' '}
              {count}{' '}
            </div>
            <button
              className={cn(
                style.incDecButton,
                style.btnRounded,
                'mx-4 btn-secondary od-dec-font-btn-color od-dec-counter-btn-color'
              )}
              style={{ fontSize: isServerApp ? '2rem' : '20px' }}
              onClick={() => setCount(count + 1)}
            >
              <i className="fas fa-plus justify-content-center align-items-center fs-50" />
            </button>
          </div>
        </div>
        <div className="col-12 p-0 h-40 row mx-0 align-items-end py-2">
          <div
            className={cn('col-12 text-center', style.divForPayment)}
            style={{ fontSize: isServerApp ? '2rem' : '20px' }}
          >
            {CUSTOM_MESSAGES().EACH_PAY}
          </div>
          <div
            className={cn('col-12 text-center', style.divForPayment)}
            style={{ fontSize: ShowLandscapeMode ? '10vw' : '20vw' }}
          >
            {LABEL().CURRENCY_SYMBOL}
            {Number(paymentAmount / count).toFixed(2)}{' '}
          </div>
          <button
            type="button"
            className="btn od-btn-primary btn-primary btn-ripple my-1 w-100"
            style={{ height: '11vh' }}
            onClick={() =>
              handleSplitEvenly(count, Number(paymentAmount / count).toFixed(2))
            }
          >
            <div
              className={cn(style.divForPayment)}
              style={{ fontSize: '40px' }}
            >
              {LABEL().CONTINUE}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const PayAnAmount = () => {
    return (
      <div className="col-12 h-100 mt-10 w-100">
        <div
          className="col-12 h-20 px-0 py-2 m-auto fw-700 text-center"
          style={{ fontSize: isServerApp ? '2rem' : '20px' }}
        >
          {CUSTOM_MESSAGES().PAY_AN_AMOUNT}
        </div>
        <Formik
          enableReinitialize
          initialValues={{ payAnAmount: 0 }}
          onSubmit={handlePayAnAmount}
          validate={validatePayAnAmount}
        >
          {() => {
            return (
              <Form className="h-100">
                <div className="col-12 p-0 h-75">
                  <SimpleKeyBoard
                    containerClass="h-100"
                    isDotRequired
                    haveCurrency={`${LABEL().CURRENCY_SYMBOL}`}
                    name="payAnAmount"
                    type="withoutDone"
                    btnName={LABEL().CONTINUE}
                    customClass={style.textBoxHeight}
                    customClassInput={style.customInputStyle}
                  />
                </div>
                <div className="col-12 p-0 h-25 d-flex justify-content-center align-items-end py-2">
                  <button
                    type="submit"
                    className="btn od-btn-primary btn-primary btn-ripple my-1 w-100"
                    style={{ height: '11vh' }}
                  >
                    <div
                      className={cn(style.divForPayment)}
                      style={{ textTransform: 'uppercase', fontSize: '40px' }}
                    >
                      {LABEL().CONTINUE}
                    </div>
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  };

  const handlePayAnAmountModal = () => {
    return (
      <Modal isOpen={paymentType === 10}>
        <div className="px-2 text-right">
          <i
            role="presentation"
            onClick={() => handleBackButton().url()}
            className="fa fa-times fs-26"
            aria-hidden="true"
          />
        </div>
        <PayAnAmount />
      </Modal>
    );
  };

  const handleSplitEvenlyModal = () => {
    return (
      <Modal
        isOpen={paymentType === 9}
        style={{ marginTop: ShowLandscapeMode ? '0vh' : '14vh' }}
      >
        <div className="px-2 text-right">
          <i
            role="presentation"
            onClick={() => handleBackButton().url()}
            className="fa fa-times fs-30"
            aria-hidden="true"
          />
        </div>
        <SplitEvenly />
      </Modal>
    );
  };

  const IngenicoPayment = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-center py-2 od-text-primary text-primary text-center">
        <div className="" style={{ marginTop: '233px', fontSize: '30px' }}>
          {tipsMessage.length > 0
            ? tipsMessage
            : CUSTOM_MESSAGES().PLEASE_CONTINUE_THE_PAYMENT}
        </div>
        {tipsMessage.length === 0 && (
          <>
            <div
              className="col-12 h-30 fs-26 p-0 text-center"
              style={{ fontSize: isServerApp ? '2rem' : '20px' }}
            >
              {CUSTOM_MESSAGES().PRESS_CONTINUE}
            </div>
            <div className="col-12 h-30 d-flex align-items-end p-0 flex-column justify-content-end ">
              {isCounter && (
                <button
                  type="button"
                  className="btn rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
                  onClick={() => handleChangePaymentType()}
                >
                  <div style={{ fontSize: isServerApp ? '2rem' : '20px' }}>
                    {LABEL().CHANGE_PAYMENT_TYPE}
                  </div>
                </button>
              )}
              <button
                type="button"
                className="btn rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
                onClick={() => handleCreditCard()}
              >
                <div style={{ fontSize: isServerApp ? '2rem' : '20px' }}>
                  {LABEL().CONTINUE}
                </div>
              </button>
            </div>
          </>
        )}
      </div>
    );
  };

  const HandlePaymentScreenType = () => {
    switch (paymentType) {
      case 1:
        return StartScreen();
      case 2:
        return Fullcheck();
      case 3:
        return (
          <Pay
            paymentCallBack={paymentCallBack}
            handleFailureRoute={handleFailureRoute}
            handleProcessCreditError={handleProcessCreditError}
            headerImg={headerImg}
            handleRouteRetry={handleRouteRetry}
          />
        );
      case 4:
        return Tips();
      case 5:
        return PaymentRecipt();
      case 6:
        return PaymentConfirmationSuccess();
      case 7:
        return PaymentConfirmationError();
      case 8:
        return PaymentErrorRetry();
      case 9:
        return handleSplitEvenlyModal();
      case 10:
        return handlePayAnAmountModal();
      case 11:
        return <Survey handleSurveySubmit={handleSurveySubmit} />;
      case 12:
        return (
          <GiftCard
            setGiftBalance={setGiftBalance}
            giftCardImages={giftCardImages}
            isSecurityCode={isSecurityCode}
            tableData={tableData}
            makeGiftCardBalanceZero={makeGiftCardBalanceZero}
            setPaymentType={setPaymentType}
            history={history}
            giftBalanceAmt={giftBalance.balanceAmount}
            paymentAmount={
              Number(totalAmount) -
              Number(paidAmount) +
              (!giftBalance?.suppressTip ? Number(tipAmount) : 0)
            }
            giftCardPayment={giftCardPayment}
            onSubmit={handleGiftCard}
            giftCardSupportsSwipe={giftCardSupportsSwipe}
            openCardPopUp={openCardPopUp}
            giftCardNumber={giftCardNumber}
            handleGiftCancel={handleGiftCancel}
            setNotification={setNotification}
            giftCardMethods={giftCardMethods}
            setTipAmount={setTipAmount}
            authInfo={authInfo}
          />
        );
      case 13:
        return <Charity />;
      case 14:
        return <QrPayFromPhone handleCheck={handleCheck} />;
      case 15:
        return <IngenicoPayment />;
      case 16:
        return (
          <CashReturn
            receiptTypes={receiptTypes}
            tableData={tableData}
            handleHideCancelIcon={handleHideCancelIcon}
            deviceInfo={deviceInfo}
            isCounter={isCounter}
            totalAmount={totalAmount}
            paymentType={paymentType}
            handleCheck={handleCheck}
            userInfo={userInfo}
            handleChangePaymentType={handleChangePaymentType}
            setErrorPopUp={props.setErrorPopUp}
          />
        );
      case 17:
        return (
          <CashReturn
            receiptTypes={receiptTypes}
            tableData={tableData}
            handleHideCancelIcon={handleHideCancelIcon}
            deviceInfo={deviceInfo}
            isCounter={isCounter}
            totalAmount={totalAmount}
            paymentType={paymentType}
            handleCheck={handleCheck}
            userInfo={userInfo}
            setErrorPopUp={props.setErrorPopUp}
          />
        );
      case 18:
        return (
          <CashReturn
            receiptTypes={receiptTypes}
            tableData={tableData}
            handleHideCancelIcon={handleHideCancelIcon}
            deviceInfo={deviceInfo}
            isCounter={isCounter}
            totalAmount={totalAmount}
            paymentType={paymentType}
            handleReceiptPopUpOpen={handleReceiptPopUpOpen}
            userInfo={userInfo}
            handleCheck={handleCheck}
            setErrorPopUp={props.setErrorPopUp}
          />
        );
      case 19:
        return <PaymentErrorRetryPreAuth />;
      case 20:
        return PaymentCallCenterConfirmationSuccess();
      case 21:
        return PaymentCallCenterConfirmationError();
      case 22:
        return confirmationAndReceiptScreen();
      case 24:
        return OtherAmount();
      case 25:
        return syncDataMisMatch();
      case 26:
        return partialPaymentError();
      case 27:
        return giftCardReceipt();
      default:
        return <div />;
    }
  };

  return <>{HandlePaymentScreenType()}</>;
};

export default PaymentScreen;
